import { FC, HTMLProps } from 'react'

import { useValidationProvider } from 'modules/ComponentValidation/hooks/useValidationProvider'

import { isMacOs } from 'utils/isMacOs'

import { useWorkingCopy } from './hooks/useWorkingCopy'

export const UndoRedoCapture: FC<HTMLProps<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  const { undoManager } = useWorkingCopy()
  const { resetValidation } = useValidationProvider()

  return (
    <div
      {...props}
      tabIndex={-1}
      onKeyDown={(evt) => {
        const isModified = isMacOs() ? evt.metaKey : evt.ctrlKey

        if (isModified) {
          if (evt.key === 'z') {
            evt.preventDefault()

            if (evt.shiftKey) {
              undoManager?.redo()
            } else {
              undoManager?.undo()
            }

            resetValidation()
          }
        }
      }}
    >
      {children}
    </div>
  )
}
